import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Footer from "../../../comum/components/Footer";
import {Row, Col, Container, FormGroup, Label, Button} from 'reactstrap';
import CabotagemCard from "./CabotagemCard";
import {IconeCarregar, IconeDelete} from "../../../comum/components/Icones";
import ModalAviso from "../../../comum/components/ModalAviso";

@inject("store")
@observer
export class TabelaCabotagemNovas extends Component{

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    };

    render() {
        return (
            <Container fluid className="tabela-container tabela-cabotagem-novas">
                <ToolkitProvider
                    keyField="pos"
                    data={[...this.controller.novasCabotagens]}
                    columns={[...this.controller.colunasN]} >
                    {props => (
                        <div>
                            { window.innerWidth > 991
                                ? <BootstrapTable bootstrap4
                                                  striped
                                                  bordered={false}
                                                  noDataIndication={() => this.controller.noData}
                                                  classes="tabela tabela-layout cabotagem"
                                                  {...props.baseProps} />
                                : <Row>
                                    {this.controller.novasCabotagens.map((card, x) => (
                                        <CabotagemCard
                                            controller={this.controller}
                                            key={x}
                                            data={card}
                                            id={x}
                                            colunas={[...this.controller.colunas]}
                                            titulo={"NavioNome"}
                                            subtitulo={"Viagem"}

                                        />
                                    )) }
                                </Row>
                            }
                        </div>)
                    }
                </ToolkitProvider>

                <Footer className = "justify-content-end">
                    { !this.controller.salvando
                        ? <React.Fragment>
                            <Button className="btn-primary" onClick={ () => this.controller.cancelarEnviar() }>CANCELAR</Button>
                            <Button className="btn-primary" onClick={ () => this.controller.salvarNovas() }>ENVIAR PARA ANÁLISE</Button>
                        </React.Fragment>
                        : <IconeCarregar tamanho="2x" cor="#001C43" />
                    }
                </Footer>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/components/TabelaCabotagemNovas.js